<div
  [hidden]="!this.show"
  class="fill-page"
  *ngIf="this.optionTemplete == 'templete'"
>
  <div class="content-wrapper">
    <div class="image-settings">
      <div
        style="background: #ccc; text-align: center"
        class="btn-close"
        (click)="this.close()"
      >
        <img class="btn-close-img" src="../../assets/images/icon_close.png" />
      </div>
      <div [innerHTML]="this.contentSplash | safeHtml"></div>
    </div>
  </div>
</div>
<div
  [hidden]="!this.show"
  class="fill-page"
  *ngIf="this.optionTemplete == 'splash'"
>
  <div class="content-wrapper">
    <div class="image-settings">
      <img class="banner" src="../../assets/images/splash_clarotv.jpg" />
      <div class="btn-close" (click)="this.close()">
        <img class="btn-close-img" src="../../assets/images/icon_close.png" />
      </div>
      <div class="btn-select" (click)="this.goTo()">
        <img
          class="btn-select-img"
          src="../../assets/images/boton_splash_clarotv.png"
        />
      </div>
    </div>
  </div>
</div>

